import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../components/client/auth/Login/Login";
import NotificationDropdown from "../components/client/NotificationDropdown/NotificationDropdown";
import ProfileDropdown from "../components/client/ProfileDropdown/ProfileDropdown";
import VerificationBanner from "./VerificationBanner";

export default function DashboardHeader() {
  const { user } = useSelector((state) => state.auth);
  const userRole = user?.role || "CUSTOMER";
  const isShipper = userRole === "SHIPPER";

  return (
    <>
      <VerificationBanner />
      <header className='header dashboard-header'>
        <nav className="navbar navbar-expand-xl navbar-dark container">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src="/image/dlogo.png" alt="Logo" />
          </Link>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav me-auto">
              {isShipper ? (
                <>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/loads">
                      Loads
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/bids">
                      My Bids
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/fleet">
                      Fleet
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/drivers">
                      Drivers
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/review">
                      Reviews
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/message">
                      Messages
                    </NavLink>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/shipment">
                      Shipments
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/track-shipment">
                      Tracking
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/payment">
                      Payments
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/message">
                      Messages
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="d-flex align-items-center gap-4 text-white navbar-nav">
            <NavLink className="nav-link text-dark" to={isShipper ? "/carrer-dashboard" : "/user-dashboard"}>
              Dashboard
            </NavLink>

            <div className="align-items-center gap-3 d-flex">
              <NotificationDropdown />
              <ProfileDropdown />
            </div>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
          </div>
        </nav>
      </header>
      <Login />
    </>
  );
}